import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ArticleService } from '../../shared/services/article.service';

@Component({
  selector: 'app-prijava',
  templateUrl: './prijava.component.html',
  styleUrls: ['./prijava.component.scss']
})
export class PrijavaComponent implements OnInit {

  form: FormGroup;
  invalid = false;
  status = PRIJAVA_STATUS.WAITING;
  PRIJAVA_STATUS = PRIJAVA_STATUS;
  eventId;

  constructor(private modalRef: BsModalRef,
              private articleService: ArticleService,
              private formBuilder: FormBuilder) {

    this.form = this.formBuilder.group({
      'Ime in priimek': ['', Validators.required],
      'E-pošta': ['', [Validators.required]],
      'Telefon': ['', [Validators.required]],
    });

  }

  ngOnInit(): void {
    console.log('eventId; ', this.eventId);
  }

  closeWindow() {
    this.modalRef.hide();
  }

  async onPrijavaClick() {

    if (this.form.valid) {

      const rawData = this.form.getRawValue();

      try {
        this.status = PRIJAVA_STATUS.SENDING;
        await this.articleService.submitApplication(this.eventId, rawData);
        this.status = PRIJAVA_STATUS.SENT;
      } catch (e) {
        this.status = PRIJAVA_STATUS.WAITING;
        alert('Prišlo je do napake zato poskusite ponovno. Če se napaka ponavlja pokličite 080 1432.');
      }

    } else {
      this.invalid = true;
    }

  }

}

export enum PRIJAVA_STATUS {
  WAITING,
  SENDING,
  SENT
}
